import React from 'react';
import { useI18n } from '../i18n/LanguageContext';

const BASE = `${process.env.PUBLIC_URL}/assets/community`;

const MOMENTS = [
  { src: `${BASE}/praise-and-worship.jpg`, key: 'praise' },
  { src: `${BASE}/candle-vigil.jpg`, key: 'vigil' },
  { src: `${BASE}/faithful-with-rose.jpg`, key: 'offering' },
  { src: `${BASE}/youth-in-prayer.jpg`, key: 'youth' },
];

function PinIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M12 21s-7-6.5-7-12a7 7 0 0 1 14 0c0 5.5-7 12-7 12z" />
      <circle cx="12" cy="9" r="2.5" />
    </svg>
  );
}

/** Past pilgrimage highlight (Tanzania) followed by a small community gallery. */
export default function PilgrimageMoments() {
  const { t } = useI18n();
  return (
    <section id="moments" className="moments">
      <div className="moments-inner">
        <article className="moments-feature">
          <div className="moments-feature-media">
            <img
              src={`${BASE}/tanzania-pilgrimage.jpg`}
              alt={t('moments.feature_alt')}
              loading="lazy"
            />
            <span className="moments-feature-tag"><PinIcon /> {t('moments.tag')}</span>
          </div>
          <div className="moments-feature-text">
            <div className="about-eyebrow">
              <span className="about-dot" /> {t('moments.eyebrow')}
            </div>
            <h2 className="moments-title">{t('moments.title')}</h2>
            <p>{t('moments.p1')}</p>
            <p>{t('moments.p2')}</p>
            <a className="moments-cta" href="#pilgrimages">{t('moments.cta')}</a>
          </div>
        </article>

        <div className="moments-heading">
          <h3>{t('moments.gallery')}</h3>
        </div>
        <div className="moments-grid">
          {MOMENTS.map((m) => (
            <figure key={m.src} className="moments-tile">
              <img src={m.src} alt={t(`moments.${m.key}_alt`)} loading="lazy" />
              <figcaption>{t(`moments.${m.key}`)}</figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
